<button class="actions-bar__button" type="button" (click)="this.clickEvent($event)" [disabled]="this.disabled" >
  <div [class]="this.badgeClass + ' ' + this.badgeColor" [hidden]="!this.badgeActive">{{this.badge}}</div>
  <span [class]="this.colorClass">
    <img *ngIf="this.src !== undefined" class="navbar-brand-full" [src]="this.src"  height="20px" >
    <i *ngIf="this.src === undefined" [class]="this.iconClass"></i>
  </span>
  <span class="actions-bar__button-label">{{this.text}}</span>
</button>